import { Star } from "lucide-react";

// Slow editorial marquee — a single continuous strip of phrases.
const Marquee = ({ items, className = "" }) => {
  const strip = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className={`relative overflow-hidden select-none ${className}`}
    >
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        {strip.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-semibold text-4xl md:text-6xl lg:text-7xl tracking-tight px-6 md:px-10">
              {item}
            </span>
            <Star
              className="h-6 w-6 md:h-9 md:w-9 text-ark-yellow shrink-0"
              fill="#FDE047"
              strokeWidth={1.5}
            />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
